import type { AdminAnnouncementEmailTemplateDefinition } from "./types";
import {
    formatListBlock,
    joinBlocks,
    splitLines,
} from "./utils";

export const generalAnnouncementTemplate: AdminAnnouncementEmailTemplateDefinition = {
    key: "GENERAL_ANNOUNCEMENT",
    label: "General Announcement",
    description:
        "A flexible broadcast layout for broad updates, reminders, and regular communication.",
    recommendedAnnouncementType: "GENERAL",
    messageLabel: "Main Message *",
    messagePlaceholder:
        "Write the core announcement body that every recipient should receive.",
    previewEyebrow: "Broadcast Email",
    previewHeaderClassName:
        "bg-[linear-gradient(135deg,#f97316_0%,#ea580c_48%,#7c2d12_100%)]",
    previewBadgeClassName:
        "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
    fields: [
        {
            id: "openingLine",
            label: "Opening Line",
            type: "text",
            placeholder: "We wanted to share a quick update with you.",
        },
        {
            id: "highlights",
            label: "Highlights",
            type: "textarea",
            placeholder: "One highlight per line",
            description: "Optional bullet-style highlights shown under the main message.",
            rows: 4,
        },
        {
            id: "callToAction",
            label: "Next Step",
            type: "text",
            placeholder: "Open the app to review the update.",
        },
    ],
    buildBody: ({ message, fields }) =>
        joinBlocks([
            fields.openingLine?.trim() ? fields.openingLine.trim() : null,
            message,
            formatListBlock("Highlights", fields.highlights || ""),
            fields.callToAction
                ? `Next step: ${fields.callToAction.trim()}`
                : null,
        ]),
    buildPreviewSections: ({ message, fields }) => [
        {
            label: "Announcement",
            body: message,
            tone: "default",
        },
        ...(splitLines(fields.highlights || "").length > 0
            ? [
                  {
                      label: "Highlights",
                      body: splitLines(fields.highlights || "").join("\n"),
                      tone: "muted" as const,
                      list: true,
                  },
              ]
            : []),
        ...(fields.callToAction?.trim()
            ? [
                  {
                      label: "Next Step",
                      body: fields.callToAction.trim(),
                      tone: "accent" as const,
                  },
              ]
            : []),
    ],
};
